import { Quote } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PoemSection = () => {
  return (
    <div className="relative z-10 animate-fade-in">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          {/* Cream frame with shadow */}
          <div className="rounded-3xl p-8 md:p-12 bg-[#FFF8E1] shadow-spark-frame">
            <div className="text-center">
              <h2 className="font-header text-3xl md:text-4xl font-bold text-[#2C003E] mb-6">
                The Poem That Inspired Our Name
              </h2>
              <p className="text-lg text-[#2C003E] mb-8 leading-relaxed">
                The Children's Hour Academy is named after the beloved poem by Henry Wadsworth Longfellow.
                The poem speaks to the magic of childhood - when young voices fill the air, imagination
                runs free, and every moment is a treasure.
              </p>
              <p className="text-lg text-[#2C003E] mb-12 leading-relaxed">
                Just as Longfellow celebrated those precious hours with his children, we honor the time
                families entrust to us. Each day at Children's Hour is crafted to nurture your child's
                natural wonder, curiosity, and joy.
              </p>

              <div className="relative bg-gradient-hero rounded-2xl p-8 md:p-12 shadow-large mb-8">
                <Quote className="absolute top-4 left-4 w-8 h-8 text-white/20" />
                <Quote className="absolute bottom-4 right-4 w-8 h-8 text-white/20 rotate-180" />
                <blockquote className="relative">
                  <p className="text-xl md:text-2xl font-serif italic text-white leading-relaxed">
                    Between the dark and the daylight,<br />
                    When the night is beginning to lower,<br />
                    Comes a pause in the day's occupations,<br />
                    That is known as the Children's Hour.
                  </p>
                  <footer className="mt-6 text-white">
                    — Henry Wadsworth Longfellow
                  </footer>
                </blockquote>
              </div>

              <Link to="/childrens-hour-poem">
                <Button variant="hero" size="lg" className="text-lg">
                  Read the Full Poem with Our Reflections
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoemSection;
